import { Col, Row } from "antd"
import BreadCrumb from "../../../../Components/BreadCrumb/BreadCrumb"

export const BreadcrumbHeader = ({ category, subCategory }) => {
  return (
    <Row>
      <Col lg={0} xs={24}>
          <BreadCrumb
              list={[
                  {
                      name: "Home",
                      link: "/",
                  },
                  {
                      name: subCategory.name,
                      link: `/category/${subCategory.slug}_${subCategory.id}`,
                  },
              ]}
          />
      </Col>
      <Col lg={24} xs={0} style={{ marginTop: 10 }}>
          <BreadCrumb
              list={[
                  {
                      name: "Back To Home",
                      link: "/",
                  },
                  {
                      name: "All Category",
                      link: "/categories",
                  },
                  {
                      name: category?.name ?? '',
                      link: "/categories",
                  },
                  {
                      name: subCategory.name,
                      link: `/category/${subCategory.slug}_${subCategory.id}`,
                  },
              ]}
          />
      </Col>
  </Row>
  )
}